export default{
  allNews: state => state.allNews,
  news: state => state.news,
}